
  <!-- 个人信息 -->
  <div class="info-wrap">
    <img
      v-if="!userInfo?.headImg"
      class="avatar"
      src="@/assets/img/person/avatar.png"
    />
    <img v-else class="avatar" :src="userInfo?.headImg" alt="" />
    <p class="name">{{ userInfo?.nickName }}</p>
  </div>
  <List
    v-model:loading="loadQuery.loading"
    :finished="loadQuery.finished"
    @load="getInfo"
  >
    <!-- 试卷列表 -->
    <ul class="ques-list">
      <li
        @click="handleJump2Detail(item)"
        v-for="item in recordList"
        :key="item.questionActiveKey"
        class="ques-item"
      >
        <img
          v-if="!item.headImg"
          class="item-img"
          src="@/assets/img/person/default-bg.png"
          alt=""
        />
        <img v-else class="item-img" :src="item.headImg" alt="" />
        <div class="item-info">
          <h3 class="title van-ellipsis">{{ item.title }}</h3>
          <p v-show="item.type === 3" class="score">
            {{ item.score !== null ? `${item.score}分` : '' }}
          </p>
          <p class="count">{{ item.amount || '--' }} 人参与</p>
        </div>
      </li>
    </ul>
  </List>
